import Panel from "components/layout/panel";
import View from "components/layout/view";
import Title from "components/title";
import UserNavigation from "components/user-navigation/user-navigation";
import { useListEntities } from "stores/hooks/list-entities";
import { useLocale } from "stores/hooks/locale";
import { parse } from "lib/locale";
import { ListEntity } from "models/list-entity";
import { FunctionComponent, useEffect, useState } from "react";
import { useParams } from "react-router";
import ListEntitySingle from "./single";
import ListEntityInstructions from "./instructions";
import UserListEntityMulti from "./multi";
import { useList } from "stores/hooks/list";
import UserStatus from "components/user-navigation/user-status";

const UserListEntityView: FunctionComponent = () => {
  const list = useList();
  const entities = useListEntities();
  const { listUuid, entityUuid } = useParams();
  const [listEntity, toggleListEntity] = useState<ListEntity | undefined>(
    undefined,
  );
  const locale = useLocale();

  useEffect(() => {
    if (entityUuid) {
      const e = entities.find((e) => e.uuid === entityUuid);
      toggleListEntity(e);
    }
  }, [entityUuid]);

  if (!list || !listEntity || !listUuid) {
    return null;
  }

  const title = parse(listEntity.name, locale);
  const instructions = parse(listEntity.instructions, locale);
  return (
    <View title={title} navigation={false}>
      <UserNavigation />
      <Panel>
        <Title>{title}</Title>
        {instructions && (
          <ListEntityInstructions>{instructions}</ListEntityInstructions>
        )}
        {!listEntity.multi && (
          <ListEntitySingle list={list} listEntity={listEntity} />
        )}
        {listEntity.multi && (
          <UserListEntityMulti list={list} listEntity={listEntity} />
        )}
        <UserStatus />
      </Panel>
    </View>
  );
};

export default UserListEntityView;
